import React, { useEffect, useState } from 'react';
import { t } from '../../locales/translate';
import { formatTime } from '../../util/formatters';
import './ActivityLog.css';

interface Props {
  date: Date | string;
}

export function TimeStamp({ date }: Props): JSX.Element {
  const [timeToDisplay, setTimeToDisplay] = useState('');

  useEffect(() => {
    const initialTime = formatTime(date, { seconds: true });

    // initial date was more than 10 seconds ago
    if ((new Date().getTime() - new Date(date).getTime()) / 1000 > 10) {
      return setTimeToDisplay(initialTime || '');
    }

    setTimeToDisplay(t.page.ticketScanner.fewSecondsAgo);
    const timeoutId = setTimeout(() => {
      if (initialTime) {
        setTimeToDisplay(initialTime);
      }
    }, 10 * 1000);

    return () => clearTimeout(timeoutId);
  }, []);

  return <span>{timeToDisplay}</span>;
}
